import saveComments from './saveComments'
import getMatches from './getMatches'
import saveObsForm from './saveObsForm'

export const getMatchesPromise = getMatches
export const saveObsFormPromise = saveObsForm
export const saveCommentsPromise = saveComments
